import React from 'react'

function Error500() {
  return (
    <main>
         <div class="error-container p-0">
    <div class="container">
        <div>
            <div>
                <img alt="" class="img-fluid" src="../assets/images/background/error-500.png"/>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <p class="text-center text-secondary f-w-500">500 Internal Server Error server error response
                            code
                            indicates that the server encountered an unexpected that prevented it from
                            fulfilling the request</p>
                    </div>
                </div>
            </div>
            <a class="btn btn-lg btn-light-info b-r-22" href="/" role="button"><i class="iconoir-home-simple"></i> Back
                To
                Home</a>
        </div>
    </div>
</div>
    </main>
  )
}

export default Error500